import styled from "styled-components";

const DescriptionHeader = styled.h2`
  font-size: 50px;
  text-transform: lowercase;
  line-height: 45px;
  font-weight: 800;
  margin-bottom: 15px;
  margin-top: 15px;
  color: #9b6940;

  @media(max-width:1599px){
    font-size: 45px;
    line-height: 40px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  @media(max-width:1199px){
    font-size: 35px;
    line-height: 35px;
    margin-bottom: 5px;
    margin-top: 5px;
  }
`;
export default DescriptionHeader;
